<template>
  <div class="Slef">
    <div class="container content_p">
      <div style="height: 0.25rem">
        <div class="top_progress">
          <el-progress :percentage="percentage"></el-progress>
        </div>
      </div>
      <div class="info">
        <div>
          <Chart>
            <h4 slot="title">个人介绍（必填）：</h4>

            <div slot="tab">
              <div class="info_desc">
                <el-form
                  :model="resumeForm"
                  :rules="resumeFormRules"
                  ref="resumeForm"
                  label-position="top"
                >
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <el-form-item label="上传个人2寸照片" prop="head_pic">
                        <div v-if="resumeForm.head_pic">
                          <img
                            :src="resumeForm.head_pic"
                            class="avatar"
                            @click="onPreviewCustomerAvatar()"
                          />
                          <el-link
                            icon="el-icon-zoom-in"
                            @click="onPreviewCustomerAvatar()"
                            style="margin-right: 20px"
                            >查看</el-link
                          >
                          <el-link
                            icon="el-icon-delete"
                            @click="onRemoveCustomerAvatar()"
                            >删除</el-link
                          >
                        </div>

                        <el-upload
                          v-else
                          action="#"
                          class="avatar-uploader"
                          list-type="picture-card"
                          :file-list="avatarFileList"
                          :limit="1"
                          :http-request="uploadCustomerAvatar"
                          :before-upload="beforeUploadCustomerAvatar"
                          :on-remove="onRemoveCustomerAvatar"
                          :on-preview="onPreviewCustomerAvatar"
                          accept="image/*"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                    <el-col :span="18">
                      <el-form-item label="自我评价" prop="self_evaluate">
                        <el-input
                          placeholder="请输入自我介绍"
                          v-model="resumeForm.self_evaluate"
                          :rows="4"
                          type="textarea"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </Chart>
        </div>
        <div style="height: 0.25rem"></div>
        <div class="sub" v-if="isUpdate">
          <el-button @click="backBtn">返回</el-button>
        </div>
        <div class="sub" v-else>
          <el-button @click="backBtn">返回</el-button>
          <el-button type="success" @click="ClickSaveBtn">完成</el-button>
        </div>
        <div style="height: 0.25rem"></div>
      </div>
    </div>
    <el-dialog title="图片预览" :visible.sync="showPic" width="80%">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import Chart from "@/components/Chart.vue";
export default {
  props: {},
  data() {
    return {
      percentage: 75,
      resumeForm: {},
      resumeFormRules: {
        head_pic:[{ required: true, message: "请上传照片", trigger: "blur" }],
      },

      //头像相关
      avatarFileList: [],
      dialogImageUrl: "",
      showPic: false,
      isUpdate: false,
    };
  },
  computed: {},
  created() {
    setTimeout(this.timer, 500);
    if (this.$query().actions == "edit") {
      this.isUpdate = true;
    }
    this.getBasicInfo();
  },
  mounted() {},
  watch: {},
  methods: {
    // 返回
    backBtn() {
      this.$router.go(-1);
    },
    // 进度条
    timer() {
      this.percentage = 87.5;
    },
    // 原始信息获取
    getBasicInfo() {
      if (this.$store.getters.isResume) {
        this.resumeForm = this.$store.getters.resume.user;
      }
      console.log("this.form", this.resumeForm);
    },
    ClickSaveBtn() {
      this.$refs.resumeForm.validate((valid) => {
        if (valid) {
          this.resumeForm.type = "jobUser";
          this.$http
            .post(`${this.$api.createResume}`, this.resumeForm, true)
            .then((res) => {
              this.$message.success("保存成功");
              // 更新vuex
              this.$store.dispatch("user/getInfo").then(() => {
                this.getBasicInfo();
              });
              // 返回电子简历首页
              this.$go("/user/resume");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // ToProject() {
    //   this.$router.push("/user/");
    // },
    // 上传图片处理
    beforeUploadCustomerAvatar(file) {
      this.fileData = new FormData();
      this.fileData.append("upload", file);
      this.fileData.append("dir", "userHeadPic");
    },
    uploadCustomerAvatar() {
      if (this.avatarFileList.length > 0) {
        this.$success("请先删除头像后，再进行上传！");
        return;
      }
      this.$http
        .upload(this.$api.editorUploadImage, this.fileData)
        .then((res) => {
          let fileContent = res.content;
          this.resumeForm.head_pic =
            process.env.VUE_APP_BASE_FILE_API + fileContent.url;
          this.$success("上传成功");
        });
    },
    onPreviewCustomerAvatar(file) {
      console.log("this.file", file);
      this.dialogImageUrl = this.resumeForm.head_pic;
      this.showPic = true;
    },
    onRemoveCustomerAvatar() {
      this.avatarFileList = [];
      this.resumeForm.head_pic = null;
      this.$store.dispatch("user/getInfo");
    },
  },
  components: {
    Chart,
  },
};
</script>

<style lang="less" scoped>
.introduction {
  margin: 0.2rem 0;
  display: flex;
  .img {
    width: 2.1rem;
    height: 2.1rem;
    background-color: rgba(192, 192, 192, 0.596);
    padding: 0.1rem;
  }
  .text {
    flex: 4;
    padding: 0 0.2rem;
    p {
      font-size: 0.14rem;
      color: #333;
    }
  }
}
.sub {
  display: flex;
  justify-content: center;
}
@media only screen and (max-width: 766px) {
  .introduction {
    flex-direction: column;
    align-items: center;
    .text {
      width: 100%;
      margin-top: 0.2rem;
      p {
        font-size: 0.24rem;
      }
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>